import React, { useState, useEffect } from "react";
import { Tab, Nav } from "react-bootstrap";
import Goals from "./goals/Goals";
import Dashboard from "./dashboard/Dashboard";
import updateParams from "utils/updateParams.js";
import IdsData from "./ids_data/IdsData";

export default function All(props) {
  const [tabLocation, setTabLocation] = useState("");

  useEffect(() => {
    let searchParams = new URL(location.href).searchParams;
    let page = searchParams.get("subpage");
    if (!page || page == "") {
      page = "ids_data";
    }
    setTabLocation(page);
    updateParams("subpage", page);
  }, []);

  const selectTab = (key) => {
    setTabLocation(key);
    updateParams("subpage", key);
  };

  return (
    <>
      <div className="px-0 px-md-5  pb-5 pt-0 ppc-config-all">
        {props.selectedPage == "all_ppc" && <input hidden name="selected_subpage" value={tabLocation} readOnly />}
        <Tab.Container id="ppc-all-subtabs" defaultActiveKey="ids_data" activeKey={tabLocation} onSelect={(k) => selectTab(k)}>
          <Nav variant="pills" className="mt-4 pb-0 nav-fill tabs-navigation-3 row no-gutters row-cols-sm-1 row-cols-md-1 row-cols-lg-3">
            <Nav.Item className="col">
              <Nav.Link eventKey="ids_data" data-link-type="subpage">Shopify Data</Nav.Link>
            </Nav.Item>
            <Nav.Item className="col">
              <Nav.Link eventKey="goals" data-link-type="subpage">Goals</Nav.Link>
            </Nav.Item>
            <Nav.Item className="col">
              <Nav.Link eventKey="dashboard" data-link-type="subpage">Dashboard</Nav.Link>
            </Nav.Item>
          </Nav>
          <Tab.Content className="pl-md-0">
            <Tab.Pane eventKey="ids_data">
              <IdsData {...props} />
            </Tab.Pane>
            <Tab.Pane eventKey="goals">
              <Goals {...props} />
            </Tab.Pane>
            <Tab.Pane eventKey="dashboard">
              <Dashboard {...props} />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    </>
  );
}
